type Props = React.PropsWithChildren<{}>

export default function Column({ children }: Props) {
  return <div className="bg-black h-full pt-12 lg:px-24 sm:px-12 px-6">{children}</div>
}
